import QuestionsSelector from './QuestionsSelector.vue';

export default QuestionsSelector;
